import React from 'react';
import { compose } from 'ramda';

import styleFile from './amenitiesList.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import RichText from '@synergycms_core/components/generic/RichText';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
//import { List } from 'immutable';

const AmenitiesList = class AmenitiesList extends React.Component {
  static displayName = 'AmenitiesList';
  render() {
    const { config, theme, content } = this.props,
      { getAmenities } = content,
      { list, maxAmenities } = config;
    const totalLength  = maxAmenities  ? maxAmenities : list.length;
    const { classes } = theme.styles;
    return (
      <div className={theme.computedInnerStyle}>
        {list.slice(0, totalLength).map(amenity => {
          return (
            <RichText
              key={amenity.get('code')}
              innerStyle={[classes.amenity, 'roboto13Gray']}
              text={amenity.get('name')}
              icon={{
                content: getAmenities(amenity.get('code')),
                innerStyle: [classes.amenityIcon]
              }}
            />
          );
        })}
      </div>
    );
  }
};

export default compose(
  PropertyManager(['list', 'maxAmenities']),
  withThemeJSS({ styleFile, index: 1000 }),
  withContent('amenities')
)(AmenitiesList);
